import { Contact } from "@type/core/dashboard/dashboard.types";

const firstLetterUpperCase = (string: string): string => {
  const first = string.substring(0, 1).toUpperCase();
  const rest = string.substring(1).toLowerCase();
  return first + rest;
};

export const getContactLabel = (contact: Contact): string => {
  return (
    (contact.firstname ? firstLetterUpperCase(contact.firstname) : "") +
    " " +
    (contact.lastname ? contact.lastname.toUpperCase() : "") +
    " - " +
    contact.email
  );
};
